var map = {
	"./ar-ab.json": "bda8",
	"./de-de.json": "060f",
	"./en-us.json": "e3b5",
	"./es-la.json": "aade",
	"./fr-fr.json": "e1cd",
	"./in-do.json": "1131",
	"./it-it.json": "67d9",
	"./ja-jp.json": "86da",
	"./ko-re.json": "c245",
	"./pt-pt.json": "ccb6",
	"./ru-ru.json": "2d83",
	"./zh-cn.json": "2c61",
	"./zh-tw.json": "cb6e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";